import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Get Assessment Results
export const getAssessmentResultsAPI = async ({ search = "" } = {}) => {
  try {
    const params = {};
    if (search) {
      params.search = search;
    }
    const response = await apiService.get(endpoints.getAssessmentResults, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};
